const DEFAULT_DATETIME_OPTIONS = {
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
};

/** Parse order timestamps; returns null instead of Invalid Date / [object Object]. */
export function formatOrderDateTime(value, options = DEFAULT_DATETIME_OPTIONS) {
  if (value == null || value === "") return null;
  if (typeof value === "object" && !(value instanceof Date)) {
    if (Object.keys(value).length === 0) return null;
    if (typeof value.toISOString !== "function") return null;
    value = value.toISOString();
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const formatted = date.toLocaleString("en-US", options);
  return formatted === "Invalid Date" ? null : formatted;
}

/** Whether admin already sent final update to customer (API field variants). */
export function isOrderFinalUpdateSent(order) {
  if (!order) return false;
  if (order.is_finalized === true || order.finalized === true) return true;
  if (order.final_update_sent === true || order.sent_to_customer === true) return true;
  // bill_generated status means bill was sent — always lock charges
  const status = String(order.order_status || '').toLowerCase();
  if (status === 'bill_generated' || status === 'paid' || status === 'packing' || status === 'shipment' || status === 'delivered') return true;
  const ts =
    order.final_update_sent_at ??
    order.finalized_at ??
    order.sent_to_customer_at;
  if (ts == null || ts === "") return false;
  if (typeof ts === "object" && !(ts instanceof Date)) return true;
  return formatOrderDateTime(ts) != null;
}

export function getFinalUpdateSentLabel(order) {
  if (!order) return null;
  return (
    formatOrderDateTime(order.final_update_sent_at) ??
    formatOrderDateTime(order.finalized_at) ??
    formatOrderDateTime(order.sent_to_customer_at) ??
    formatOrderDateTime(order.updatedAt)
  );
}
